import type { GridColDef, GridValidRowModel } from '@mui/x-data-grid';
import { isNullOrUndefined } from '@vy/utils';
import { VY_TABLE_FUNCTIONAL_COLUMNS_KEYS } from '../components/new-design/table/vy-table/vy-table-types';

type UseColumnStateProps<Item extends GridValidRowModel> = {
  columns: GridColDef<Item>[];
  rows: Item[];
  excludeKeys?: string[];
  mandatoryKeys: string[];
};

export function useColumnState<Item extends GridValidRowModel>({
  columns,
  rows,
  excludeKeys,
  mandatoryKeys,
}: UseColumnStateProps<Item>) {
  const checkRowForColumnData = (row: Item, column: GridColDef) => {
    const field = column.field as keyof Item;

    return isNullOrUndefined(row[field]);
  };

  const isColumnExcluded = (column: GridColDef) =>
    excludeKeys?.includes(column.field) || VY_TABLE_FUNCTIONAL_COLUMNS_KEYS.includes(column.field);

  const isColumnMandatory = (column: GridColDef) => mandatoryKeys.includes(column.field);

  const isColumnWithoutData = (column: GridColDef) => {
    return rows.every(
      (row) => checkRowForColumnData(row, column) && !isColumnExcluded(column) && !isColumnMandatory(column),
    );
  };

  const filterColumnsWithoutData = () => {
    return columns.filter(isColumnWithoutData);
  };

  const initialState = () => {
    const initial: Record<string, boolean> = {};

    const emptyColumns = filterColumnsWithoutData();

    emptyColumns.forEach((column) => {
      initial[column.field] = false;
    });

    return initial;
  };

  return initialState();
}
